const TOPICS = [
  { id: 1, name: '热血少年', count: '12.8万', hot: true },
  { id: 2, name: '恋爱甜宠', count: '10.5万', hot: true },
  { id: 3, name: '奇幻冒险', count: '9.2万', hot: true },
  { id: 4, name: '悬疑推理', count: '7.6万', hot: false },
  { id: 5, name: '搞笑日常', count: '8.3万', hot: false },
  { id: 6, name: '都市言情', count: '6.9万', hot: false },
  { id: 7, name: '玄幻修仙', count: '11.4万', hot: true },
  { id: 8, name: '末日求生', count: '5.2万', hot: false },
  { id: 9, name: '机甲科幻', count: '4.8万', hot: false },
  { id: 10, name: '校园青春', count: '7.1万', hot: false },
  { id: 11, name: '国漫精选', count: '9.8万', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            当下最受读者关注的漫画话题，找到属于你的阅读圈子
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic) => (
            <div
              key={topic.id}
              className={`group flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all duration-300 cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-primary-100/70 border-primary-300 text-primary-800 hover:bg-primary-200/70'
                  : 'bg-background-50 border-background-200 text-foreground-700 hover:border-foreground-300'
              }`}
            >
              <span className="text-sm font-medium">{topic.name}</span>
              <span className={`text-xs ${topic.hot ? 'text-primary-600' : 'text-foreground-500'}`}>
                {topic.count}
              </span>
              {topic.hot && (
                <span className="text-[10px] px-1 py-0.5 rounded bg-primary-500 text-background-50 font-semibold">热</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}